import { FC } from "react";
import styled from "styled-components";
import { FormattedCategory } from "./CategoryWrapper";

const Category = styled.a`
  display: flex;
  font-size: 36px;
  font-style: normal;
  font-weight: 500;
  line-height: 1.1;
  letter-spacing: -0.96px;
  margin-bottom: 16px;
  cursor: pointer;
  border-bottom: 3px solid transparent;
  text-decoration: none;
  text-wrap: nowrap;
  color: #191A1F;

  sup {
    margin-left: 4px;
    color: #191A1F;
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: 0.1px;
  }

  @media (min-width: 1024px) {
    margin-bottom: 20px;
    opacity: 0.5;
    font-size: 64px;
    font-style: normal;
    line-height: 60px;
    letter-spacing: -1.28px;
    &:hover {
      opacity: 1;
      transition: opacity 0.3s ease-in-out;
      border-bottom: 3px solid black;
    }
    &.active {
      opacity: 1;
    }
    sup {
      font-size: 14px;
      line-height: 22px;
      letter-spacing: 0.14px;
    }
  }
`;

const CategoryLink: FC<FormattedCategory> = ({
  url,
  title,
  productCount,
  onHover,
}) => {
  return (
    <Category
      href={url}
      onMouseEnter={() => onHover?.(true)}
      onMouseLeave={() => onHover?.(false)}
    >
      {title}
      <sup>{productCount}</sup>
    </Category>
  );
};

export default CategoryLink;